import {useState} from 'react'
import ShareLinkForm from './components/ShareLinkForm'
import ShareVideoPreView from './components/ShareVideoPreView'

const ShareLinkPage = () => {
  const [verifyStatus, setVerifyStatus] = useState<boolean>(false)
  const [data, setData] = useState<any>(null)

  return (
    <>
      {!verifyStatus ? (
        <ShareLinkForm setVerifyStatus={setVerifyStatus} setData={setData} />
      ) : (
        <ShareVideoPreView data={data} />
      )}
    </>
  )
}

export default ShareLinkPage
